/**
 * @file routes/_app/audit/route.tsx
 * @description 稽核專區 Layout 路由（M1）。
 *
 * 所有 audit/* 子路由（orgs, notices, records, lab-reports, organic-materials）的佈局容器。
 * 直接渲染 Outlet，無額外包裝。
 */

import { Outlet, createFileRoute } from '@tanstack/react-router';

/** TanStack Router 路由定義 */
export const Route = createFileRoute('/_app/audit')({
  component: () => <Outlet />,
});
